import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router";

import "./notification.css";
import RetryPaymentWithCardModal from "./RetryPaymentWithCardModal";
import { AuthContext } from "../../../../Context/AuthContext";

const PaymentFailedNotification = () => {
  const { t: locale } = useTranslation();
  const { pathname } = useLocation();
  // const [show, setShow] = useState(false);
  const [redirectTo, setRedirectTo] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { authData } = useContext(AuthContext);
  const [planData, setPlanData] = useState(null);

  useEffect(() => {
    if (authData?.subscription) {
      setPlanData(authData?.subscription || null);
    }
  }, [authData]);

  // useEffect(() => {
  //   if (planData !== null) {
  //     setShow(true);
  //   }
  // }, [planData]);

  // // const closePopup = () => {
  // //   setShow(false);
  // // };

  /******/
  if (redirectTo) {
    return <Navigate to={"/settings/accounts-and-billing"} />;
  }
  if (
    planData?.payment_status === "failed" &&
    pathname !== "/settings/accounts-and-billing"
  )
    return (
      <React.Fragment>
        <div className="pt-2 pb-3 pb-sm-2 px-4 top-navigation payment-failed-box">
          <Row className="align-items-center">
            <Col>
              <div className="d-flex align-items-center">
                <i className="ri-information-fill me-2"></i>
                <p className="m-0">
                  Your payment has failed. Please retry to continue
                  subscription.
                </p>
              </div>
            </Col>
            <Col sm="auto" className="pe-0 ps-5 ps-sm-2"></Col>
            <Col sm="auto" className="ps-0 top-nav-close">
              <button
                className="btn btn-primary"
                onClick={() => {
                  setShowModal(true);
                }}
              >
                Retry Payment
              </button>
            </Col>
          </Row>
        </div>
        <RetryPaymentWithCardModal
          showModal={showModal}
          setShowModal={setShowModal}
          locale={locale}
          planData={planData}
        />
      </React.Fragment>
    );
  return "";
};

export default PaymentFailedNotification;
